<template>
  <Transition
    enter-active-class="tw:transition-all tw:duration-300 tw:ease-in-out"
    enter-from-class="tw:max-h-0 tw:opacity-0"
    enter-to-class="tw:max-h-40 tw:opacity-100"
    leave-active-class="tw:transition-all tw:duration-300 tw:ease-in-out"
    leave-from-class="tw:max-h-40 tw:opacity-100"
    leave-to-class="tw:max-h-0 tw:opacity-0"
  >
    <div v-if="isActive" class="tw:overflow-hidden tw:w-full">
      <p class="tw:body-2 tw:flex tw:gap-1 tw:my-1">
        {{ translation.inputLabel }}
      </p>
      <div class="tw:flex tw:gap-2 tw:mt-2 tw:w-full">
        <EdroneSliderInput
          class="FreemiumUpgradeDrawerManageContacts__slider tw:flex-1 tw:min-w-0"
          :min="1"
          :max="customersCount"
          :step="1"
          :value="selectedContacts"
          @update-value="handleSliderChange"
        />
        <EdroneNumberInput
          unique-id=""
          class="tw:w-[9.375rem]"
          :value="selectedContacts"
          :max="customersCount"
          :min="1"
          @update-value="handleSliderChange"
        />
      </div>
      <p class="tw:caption tw:mt-1">
        {{ translation.inputHelper.replace("{contacts}", plan?.upToUnits?.toString() || "--") }}
      </p>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed, inject, onBeforeUnmount } from "vue";
import { debounce } from "lodash";
import { amplitudeSendEvent } from "vue-app/utils/amplitude.ts";
import { symbolMachineFreemium } from "vue-app/components/Freemium/Freemium.machine.ts";
import { Customers, useFreemiumStore } from "vue-app/components/Freemium/Freemium.store.ts";
import { storeToRefs } from "pinia";
import EdroneNumberInput from "edrone-components/EdroneNumberInput.vue";
import EdroneSliderInput from "edrone-components/EdroneSliderInput.vue";

interface Props {
  isActive?: boolean;
}

withDefaults(defineProps<Props>(), {
  isActive: false,
});

const actor = inject(symbolMachineFreemium);
const store = useFreemiumStore();
const { customersCount, selectedContacts, selectedCustomersOption, recommendedCustomersCount } = storeToRefs(store);

const debouncedAmplitudeEvent = debounce(() => {
  amplitudeSendEvent("Freemium_Contacts_Slider_Changed");
}, 500);

onBeforeUnmount(() => {
  debouncedAmplitudeEvent.cancel();
});

function handleSliderChange(value: number) {
  debouncedAmplitudeEvent();
  actor?.send({ type: "SELECT_CONTACTS", contacts: value });
}

const billedContactsCount = computed(() => {
  if (selectedCustomersOption.value === Customers.Manual) {
    return selectedContacts.value;
  }
  if (selectedCustomersOption.value === Customers.Recommended) {
    return recommendedCustomersCount.value;
  }
  return customersCount.value;
});

const plan = computed(() => {
  return store.getPlan(billedContactsCount.value);
});

const translation = window._trans._freemium.upgradeDrawer.optionManual;
</script>

<style lang="scss">
.FreemiumUpgradeDrawerManageContacts__slider .EdroneSliderInput__thumb {
  display: none;
}
</style>
